import { useContext } from "react";
import { Route, Routes } from "react-router-dom";

import { AppRulesContext } from "../App";
import GuardedRoute from "../components/GuardedRoute";
import PageNotFound from "../pages/PageNotFound";
import AFPlanAddEdit from "../pages/plan-config/AFPlanAddEdit";
import AFPlans from "../pages/plan-config/AFPlans";
import PricingPageSettings from "../pages/plan-config/PricingPageSettings";
import SelfFilingsPlans from "../pages/plan-config/SelfFilingsPlans";

const PlanNavigator = () => {
  const { rulesSvc } = useContext(AppRulesContext);

  return (
    <Routes>
      <Route
        path="self-filings"
        element={<GuardedRoute rules={rulesSvc.updatePlan} element={<SelfFilingsPlans />} />}
      />
      <Route
        path="assisted-filings"
        element={<GuardedRoute rules={rulesSvc.plansList} element={<AFPlans />} />}
      />
      <Route
        path="assisted-filings/add"
        element={<GuardedRoute rules={rulesSvc.createPlan} element={<AFPlanAddEdit />} />}
      />
      <Route
        path="assisted-filings/edit/:uUId"
        element={<GuardedRoute rules={rulesSvc.updatePlan} element={<AFPlanAddEdit />} />}
      />
      <Route
        path="footer-settings"
        element={<GuardedRoute rules={rulesSvc.usersList} element={<PricingPageSettings />} />}
      />

      {/* URL Not Found */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default PlanNavigator;
